import Repository from '../axios'


export default {
  getDashboardSummary(account_id = '') {
    return Repository.get(`/admin/dashboard-summary?account_id=${account_id}`)
  },
  getDashboardPdf() {
    return Repository.get(`/auth/test-pdf`)
  },
  getDashboardReport(account_id = '') {
    return Repository.get(`/admin/report-data?account_id=${account_id}`)
  },
  getAttachmentScreens(object_name = '') {
    return Repository.get(`/admin/attachment-screens?object_name=${object_name}`)
  }
};
